// @ts-check
import React, { useMemo } from 'react';

import Title from './Title';
import Sanitize from "@/src/shared/components/Sanitize";

/** 
 * @param {{ profile: import("@/pages/about/leadership/senior-staff/[slug]").IChartProfile }} props 
 */
export default function ChartProfile({ profile }) {
  const bio = useMemo(
    () => profile.Background.replace(/((?:\n|\r|<br\s?\/?>)+)/gm, '<br><br>'), 
    [profile.Background]
  );

  return (
    <div>
      <Title name={profile.Name} image={profile.Picture} title={profile.Title} />
      <Sanitize>{bio ?? ''}</Sanitize>
    </div>
  );
};